import { ChartOptionsModalComponent } from './../ChartOptionsModal/ChartOptionsModal.component';
import { Component, OnInit, ElementRef, HostBinding } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColorEvent } from 'ngx-color';
import { WorkspaceServiceService } from '../../../services/workspace-service.service';

@Component({
  selector: 'mobile-chart-options-modal',
  template: require('./mobile-chart-options-modal.component.html'),
  styles: [require('./mobile-chart-options-modal.component.css')]
})
export class MobileChartOptionsModalComponent extends ChartOptionsModalComponent 
{
  colorPickerMode = false;
  defaultPickerColor = '#FFFFFF';
  colorPickerTitle = 'Pick a color';

  @HostBinding('class.horizontal')
  get horizontal()
  {
    return this.workspaceService.data.horizontalMode;
  }

  footerHeight: string = '0px';
  toolbarHeight: string = '0px';

  get pickerHeight()
  {
    return 'calc(100% - ' + this.toolbarHeight + ' - ' + this.footerHeight + ')'
  }

  get pickerTop()
  {
    return this.toolbarHeight;
  }

  get pickerMaxWidth()
  {
    return 'calc(95vh - ' + this.toolbarHeight + ' - ' + this.footerHeight + ')'
  }

  customFieldsLabels: { [field: string]: string} =
  {
    'LineSeriesColor': 'Charting Priceline',
    'CandleStickSerieBorderColor': 'Candle Border',
    'CandleStickSerieFallingColor': 'Bearish Candle',
    'CandleStickSerieRisingColor': 'Bullish Candle'
  }

  fields: string[] = [];

  get selectedField()
  {
    if(this.colorPickerMode)
      return 'colorPickerMode';

    return this._selectedField;
  }

  set selectedField(v)
  {
    this.lastColorEvent = undefined;
    this._selectedField = v;
  }
  
  _selectedField?: string;

  get selectedFieldColor(): string | undefined
  {
    if(this.colorPickerMode)
      return this.defaultPickerColor;

    if(this.selectedField)
      return this.form.value[this.selectedField];
  }

  lastColorEvent?: ColorEvent;

  constructor(public activeModal: NgbActiveModal, protected element: ElementRef, protected workspaceService: WorkspaceServiceService) { super(activeModal, element); (window as any).mcom = this;}

  confirmPickedColor()
  {
    if(!this.lastColorEvent)
      return;

    if(this.colorPickerMode)
    {
      this.activeModal.close(this.lastColorEvent);
      return;
    }

    if(this.selectedField)
      this.form.value[this.selectedField] = this.lastColorEvent.color.hex;
  }

  cancelColorPicker()
  {
    if(this.colorPickerMode)
      this.activeModal.dismiss();
      
    this.selectedField = undefined;
  }

  getFieldLabel(field: string)
  {
    return this.customFieldsLabels[field] || field.replace('Color', '').replace(/([A-Z])/g, ' $1').trim();
  }

  getFieldColor(field: string): string | undefined
  {
    return this.form.value[field];
  }

  ngAfterViewInit() : void
  {
    super.ngAfterViewInit();
    this.fields = Object.keys(this.form.value).filter(field => field.indexOf('Color') != -1);
  }

}
